import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getFooterContent } from '../redux/actions/footerContentActions';
import { ICombineReducerType } from '../redux/reducers';
import useLanguageDir from '../utils/Hooks/useLanguageDir';

interface IFooterDetails {
    footerTitle: string;
    footerSubTitle: string;
    footerDesc: string;
}

const FooterContent = () => {
    const { i18n, t } = useTranslation();
    const [is_expand, setIsExpand] = useState(false);
    const { language_dir } = useLanguageDir();
    const dispatch = useDispatch();

    const footerContentData = useSelector(
        (state: ICombineReducerType) => state.footerContent
    );

    const [footerContent, setFooterContent] = useState<IFooterDetails>({
        footerTitle: '',
        footerSubTitle: '',
        footerDesc: ''
    });

    useEffect(() => {
        getFooterContent(dispatch);
    }, []);

    useEffect(() => {
        let currentLang = i18n.language;
        if (footerContentData) {
            const footerDetails =
                footerContentData?.footerContent?.details.find(
                    (item) => item?.lang === currentLang
                );
            if (footerDetails) {
                setFooterContent({
                    footerTitle: footerDetails.title,
                    footerSubTitle: footerDetails.sub_title,
                    footerDesc: footerDetails.description
                });
            } else {
                setFooterContent({
                    footerTitle:
                        footerContentData?.footerContent?.details[0].title ??
                        '',
                    footerSubTitle:
                        footerContentData?.footerContent?.details[0]
                            .sub_title ?? '',
                    footerDesc:
                        footerContentData?.footerContent?.details[0]
                            .description ?? ''
                });
            }
        }
    }, [footerContentData, i18n.language]);

    return (
        <>
            {footerContentData && (
                <div className="footer-info-content">
                    <div className="padding">
                        <h2 className="footer-title" dir={language_dir}>
                            {footerContent.footerTitle}
                        </h2>
                        <div
                            className={`footer-subtitle ${
                                is_expand ? '' : 'truncate-block'
                            }`}
                            dangerouslySetInnerHTML={{
                                __html: footerContent.footerDesc
                            }}
                        />
                        <div>
                            <button
                                className="footer-read-more-btn text-uppercase"
                                onClick={() => setIsExpand(!is_expand)}
                            >
                                {is_expand ? t('showLess') : t('readMore')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FooterContent;
